import * as theme from "../theme";

import React, { useState } from "react";

import Button from "../components/CustomButton";
import Context from "../contexts/data";
import CustomInput from "../components/inputs/CustomInput";
import ErrorMessage from "../components/ErrorMessage";
import HeaderText from "../components/HeaderText";
import InputContainer from "../components/inputs/InputContainer";
import RateZipSlider from "../components/StyledSlider";
import { formatCurrency } from "../util/regex";
import { handleRedirection } from "../util/httpHelpers";
import styled from "styled-components";

const HomeAmount = () => {
  const { homeValue, errorMessage, handleUpdateFormValue, navigate } =
    React.useContext(Context);

  const [homeValueText, setHomeValueText] = useState(formatCurrency(homeValue));

  const handleNextStep = () => {
    if (homeValue > 2000000) {
      handleUpdateFormValue(
        "errorMessage",
        "Select a home value less than or equal to $2,000,000."
      );
      return;
    } else if (homeValue < 100000) {
      handleUpdateFormValue(
        "errorMessage",
        "Select a home value greater than or equal to $100,000."
      );
    } else if (homeValue < 200000) {
      handleRedirection("homeValue");
    } else {
      const updatedMortgageBalance = Math.floor(homeValue * 0.25);
      handleUpdateFormValue("errorMessage", "");
      handleUpdateFormValue("mortgageBalance", updatedMortgageBalance);

      navigate("mortgage-balance", "Home Value");
    }
  };

  const handleChange = ({ target }) => {
    const { value } = target;
    const { textMoney, intMoney } = formatCurrency(value, "both");

    if (intMoney !== 0) {
      setHomeValueText(textMoney);
      handleUpdateFormValue("homeValue", intMoney);
    } else {
      setHomeValueText("");
      handleUpdateFormValue("homeValue", "");
    }
  };

  return (
    <Wrapper>
      <HeaderText bigger_text={"Estimated home value"} />
      <RateZipSlider
        range="$100,000 - $2,000,000+"
        min={100000}
        max={2000000}
        value={homeValue}
        handleChange={handleChange}
        step={50000}
      />
      <InputContainer inputClass={"genericContainer"}>
        <CustomInput
          value={"$" + homeValueText}
          errorMessage={errorMessage}
          fieldClass="numberInput"
          onChange={handleChange}
          name={"Home Value"}
          labelName={"Home Value"}
        />
      </InputContainer>
      <ErrorMessage />
      <Button onClick={handleNextStep} />
    </Wrapper>
  );
};

const Wrapper = styled(theme.column_align)`
  @media (max-width: ${theme.mobile}) {
    margin-bottom: 16px;
  }
`;

export default HomeAmount;
